import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NgAceActionService {
  private readonly _actionEvent = new Subject<{ selector: string; action: string }>();
  private readonly _preventEvent = new Subject<{ selector: string; event: string; prevent?: boolean }>();

  action(selector: string, action: string): void {
    this._actionEvent.next({ selector, action });
  }

  prevent(selector: string, event: string): void {
    const prevent = true;
    this._preventEvent.next({ selector, event, prevent });
  }

  unPrevent(selector: string, event: string): void {
    const prevent = false;
    this._preventEvent.next({ selector, event, prevent });
  }

  onAction(): Observable<{ selector: string; action: string }> {
    return this._actionEvent.pipe(share());
  }

  onPrevent(): Observable<{ selector: string; event: string; prevent?: boolean }> {
    return this._preventEvent.pipe(share());
  }
}
